const data = require('./raw/memories.json');

if (process.env.gatsby_executing_command === 'develop') {
  // Add some items with testing values
  data.push();
}

module.exports = data;



// WEBPACK FOOTER //
// ./data/memories.js